import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Helper from '../../../helpers/Helper';
import * as styles from './style';
import MenuListHelper from '../MenuListHelper';

const renderServiceTypeNames = (serviceTypes = []) => {
  let menu = {};
  serviceTypes.forEach(type => {
    menu = {
      ...menu,
      [type.value]: true,
    };
  });
  return Helper.formatServiceTypeNames(menu);
};

const getSelectedMarketplaces = marketplaces => {
  return marketplaces
    .filter(mktpc => mktpc.active && !mktpc.disabled)
    .map(mktpc => mktpc.name)
    .join(', ');
};

const MenuResumeHelper = ({ marketplaces, serviceTypes, mktpcHovered, menus }) => {
  return (
    <Fragment>
      <styles.MenuResume>
        <styles.Title style={{ marginBottom: '30px' }}>Resumo do Cardápio</styles.Title>
        <styles.MarketplacesName>{getSelectedMarketplaces(marketplaces)}</styles.MarketplacesName>
        <styles.MenuType>{renderServiceTypeNames(serviceTypes)}</styles.MenuType>
        <styles.LineSeparator />
      </styles.MenuResume>
      <styles.HelperMarketplaces hoverMktpcStyle={mktpcHovered}>
        <styles.TagMktpcContainer hoverMktpcStyle={mktpcHovered}>
          {mktpcHovered ? (
            <styles.MenuWith>
              Cardápios com <styles.HoverMktpc>{mktpcHovered.name}</styles.HoverMktpc>
            </styles.MenuWith>
          ) : (
            <styles.Tag />
          )}
          <styles.LineHelper hoverMktpcStyle={mktpcHovered} />
        </styles.TagMktpcContainer>
        {mktpcHovered ? (
          <MenuListHelper
            marketplaces={[mktpcHovered]}
            menus={menus.filter(menu => menu.marketplaces.some(mktpc => mktpc === mktpcHovered.id))}
            customStyle={{ marginTop: '0' }}
          />
        ) : (
          <styles.InfoHelper>
            <styles.HelpTitle>Marketplaces Indisponíveis</styles.HelpTitle>
            <styles.HelpDesc>
              pois já possuem cardápios Delivery e No Local cadastrados.
            </styles.HelpDesc>
            <styles.HelpDesc>
              Passe o mouse sobre o Marketplace para ver quais cardápios eles fazem parte.
            </styles.HelpDesc>
          </styles.InfoHelper>
        )}
      </styles.HelperMarketplaces>
    </Fragment>
  );
};

MenuResumeHelper.propTypes = {
  marketplaces: PropTypes.array,
  serviceTypes: PropTypes.array,
  mktpcHovered: PropTypes.object,
  menus: PropTypes.array,
};

export default MenuResumeHelper;



// WEBPACK FOOTER //
// ./src/components/CreateMenuModal/MenuResumeHelper/index.js